var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M11.125 1.75V8.625M14.25 6.625V3.75C14.25 3.04993 14.25 2.6999 14.1138 2.43251C13.994 2.19731 13.8027 2.00608 13.5675 1.88624C13.3001 1.75 12.9501 1.75 12.25 1.75H5.57379C4.66036 1.75 4.20365 1.75 3.83477 1.91715C3.50966 2.06446 3.23335 2.30151 3.03831 2.60045C2.81701 2.93962 2.74757 3.39102 2.60867 4.29383L2.28175 6.41883C2.09856 7.60957 2.00697 8.20494 2.18366 8.6682C2.33875 9.07481 2.63044 9.41481 3.00873 9.62992C3.43974 9.875 4.04212 9.875 5.24687 9.875H5.75003C6.10007 9.875 6.27508 9.875 6.40878 9.94312C6.52638 10.003 6.62199 10.0987 6.68191 10.2163C6.75003 10.35 6.75003 10.525 6.75003 10.875V12.7089C6.75003 13.56 7.44003 14.25 8.29118 14.25C8.4942 14.25 8.67817 14.1304 8.76062 13.9449L10.8611 9.21886C10.9566 9.00391 11.0044 8.89643 11.0799 8.81762C11.1466 8.74796 11.2286 8.69469 11.3194 8.66199C11.4221 8.625 11.5397 8.625 11.7749 8.625H12.25C12.9501 8.625 13.3001 8.625 13.5675 8.48876C13.8027 8.36892 13.994 8.17769 14.1138 7.94249C14.25 7.6751 14.25 7.32507 14.25 6.625Z",
    stroke: "#676A73",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownIcon);
export default __webpack_public_path__ + "static/media/Thumbs_Down_Icon.e64b29e0ccaf2106b743194646a5b476.svg";
export { ForwardRef as ReactComponent };